<mat-card class="mat-card--widget">
  <mat-card-content class="order-card">
    <div class="row">
      <div class="col s12 m6 l6">
        <h2>{{ cart.firstName }} {{ cart.lastName }}</h2>
      </div>
      <div class="col s12 m6 l6 text-align-right">
        <h2>Created On: {{ cart.createdOn | date: 'shortDate' }}</h2>
      </div>
      <div class="col s12 m6 l6">
        <h4>Email : {{ cart.email }}, Phone : {{ cart.phoneNumber }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <!-- Data Table -->
        <div class="data-table mt-15">
          <div
            class="data-table-header mat-header-row collection__table-header-mobile"
            matSort
            (matSortChange)="sortData($event)"
          >
            <span>
              <span
                class="col s12 data-table-cell data-table-cell-show-small"
                mat-sort-header="smallImageUrl"
                disableClear
              >
                Frame Details
              </span>
            </span>
          </div>
          <div
            class="data-table-header mat-header-row collection__table-header-desktop"
            matSort
            (matSortChange)="sortData($event)"
          >
            <!--s2 s2 s2 s1 s2 s1 s1 s1-->
            <span
              class="col s2 data-table-cell data-table-cell-show-small"
              mat-sort-header="smallImageUrl"
              disableClear
            >
              Image
            </span>
            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="brandName" disableClear>
              Brand Name
            </span>
            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="styleName" disableClear>
              Style Name
            </span>

            <span
              class="col s2 data-table-cell data-table-cell-show-small"
              mat-sort-header="colorDescription"
              disableClear
            >
              Color
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="eyeSize" disableClear>
              Size
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="upc" disableClear>
              UPC
            </span>
          </div>
          <section class="data-table-tbody">
            <div class="row data-table-row" *ngFor="let frame of sortedData; let i = index">
              <div class="col s12 m12 l2 data-table-cell product-item__image">
                <div class="data-table-data frame--image">
                  <img
                    [src]="frame['smallImageUrl']"
                    [alt]="frame['smallImageUrl']"
                    class="collection__frame-image"
                    onError="this.src='/assets/images/frame-default-sm.png'"
                  />
                </div>
                <div class="row hide-desktop">
                  <div class="col s12">
                    <div class="row">
                      <div class="col s12">
                        <button class="accordion" (click)="(panelDisplay[i] === 'block' ? 'none' : 'block')">
                          {{ frame['brandName'] }} | {{ frame['styleName'] }} | {{ frame['colorDescription'] }}
                        </button>
                        <div class="panel" [ngStyle]="{ display: panelDisplay[i] }">
                          <div class="row">
                            <div class="col s12">
                              <div class="row">
                                <div class="col s4">
                                  <strong>Size</strong>
                                </div>
                                <div class="col s8">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>UPC</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['upc'] }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['brandName'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['styleName'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['colorDescription'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['upc'] }}</span>
              </div>
            </div>
          </section>
        </div>
        <div
          class="col s12 m6 l6"
          *ngIf="
            cart.lensRecommendations !== null &&
            cart.lensRecommendations !== '' &&
            cart.lensRecommendations !== undefined
          "
        >
          <h4>Recommended lenses : {{ cart.lensRecommendations }}</h4>
        </div>
        <!-- END Data Table -->
      </div>
    </div>
    <div class="row">
      <div class="col s12 align-right">
        <div class="btn-group btn-group--wrap">
          <div class="container">
            <div class="text-block text-align-right">
              <button class="btn btn-block btn-outline" (click)="deleteCart(cart)">Delete</button>
              <ng-container *ngIf="processedImage > 0 || totalFrames > 0; else normalButton">
                <button
                  class="btn btn-block btn-primary"
                  (click)="printCart(cart)"
                  [disabled]="processedImage > 0 || totalFrames > 0"
                >
                  Generating PDF Report. Processing {{ processedImage }} of {{ totalFrames }}
                </button>
              </ng-container>
              <ng-template #normalButton>
                <button class="btn btn-block btn-primary" (click)="printCart(cart)">Print This Cart</button>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
